module.exports = __webpack_public_path__ + "static/segregation-4f3bc9a55501dca30a0df916012a0995.gif";